import { Layout } from "../components/Layout";

/** Legal page (route "/agb") — kept directly on the landing site so it stays
 *  reachable independent of the app's own gate. */
export function Agb(): JSX.Element {
  return (
    <Layout>
      <div className="container-welope py-14 sm:py-20 lg:py-24">
        <div className="mx-auto max-w-2xl">
          <nav aria-label="Brotkrumen" className="mb-6">
            <ol className="flex flex-wrap items-center gap-2 font-body text-label-sm text-on-surface-variant">
              <li>
                <a href="/" className="transition-colors hover:text-primary">
                  Start
                </a>
              </li>
              <li aria-hidden>›</li>
              <li className="text-primary">AGB</li>
            </ol>
          </nav>

          <h1 className="font-headline text-[34px] font-extrabold leading-[1.1] tracking-[-0.02em] text-primary sm:text-[46px]">
            Allgemeine Geschäftsbedingungen (AGB) / Nutzungsbedingungen
          </h1>

          <div className="mt-10 space-y-10">
            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                § 1 Geltungsbereich und Vertragsgegenstand
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Diese Nutzungsbedingungen regeln das Vertragsverhältnis zwischen solutioIT
                (Inhaber: Jamie Hennemann, nachfolgend "Welope", "wir") und den Nutzer:innen
                (nachfolgend "Sie", "Nutzer:in") der Plattform Welope, einem sozialen Netzwerk für
                Haustierbesitzer:innen, erreichbar über die Website sowie die iOS- und Android-App
                (gemeinsam "die Plattform"). Welope ermöglicht insbesondere das Anlegen von
                Nutzer- und Tierprofilen, das Veröffentlichen von Beiträgen, Fotos und Videos, die
                private Kommunikation mit anderen Nutzer:innen, das Folgen anderer Profile und
                Gruppen sowie – bei ausdrücklicher Einwilligung – die standortbasierte Anzeige von
                Nutzer:innen in der Nähe. Mit der Registrierung erkennen Sie diese
                Nutzungsbedingungen an.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                § 2 Registrierung und Nutzerkonto
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Die Nutzung von Welope setzt die Registrierung eines Nutzerkontos mit gültiger
                E-Mail-Adresse voraus. Die Registrierung und Nutzung ist Personen ab 16 Jahren
                gestattet; Minderjährige benötigen die Zustimmung ihrer Erziehungsberechtigten.
                Sie sind verpflichtet, bei der Registrierung wahrheitsgemäße Angaben zu machen und
                Ihre Zugangsdaten (insbesondere Ihr Passwort) geheim zu halten sowie vor dem
                Zugriff Dritter zu schützen. Für Aktivitäten, die unter Verwendung Ihrer
                Zugangsdaten vorgenommen werden, haften Sie, sofern Sie den Missbrauch zu
                vertreten haben. Ein Nutzerkonto ist nicht übertragbar. Pro Person darf nur ein
                Nutzerkonto angelegt werden.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                § 3 Pflichten der Nutzer:innen
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Bei der Nutzung von Welope verpflichten Sie sich,
              </p>
              <ul className="mt-4 space-y-2">
                {[
                  "keine rechtswidrigen Inhalte einzustellen, insbesondere keine Inhalte, die gegen geltendes Recht verstoßen (z. B. Volksverhetzung, Beleidigung, üble Nachrede, Gewaltverherrlichung, Verstöße gegen den Tier- oder Jugendschutz);",
                  "keine Belästigung, Hassrede, Diskriminierung, Mobbing oder Bedrohung anderer Nutzer:innen zu betreiben – weder öffentlich noch über private Nachrichten;",
                  "nur Inhalte hochzuladen, an denen Sie die erforderlichen Urheber-, Marken- und sonstigen Nutzungsrechte besitzen, und keine Rechte Dritter (insbesondere Urheber-, Persönlichkeits- oder Markenrechte) zu verletzen;",
                  "keine Fotos oder Videos anderer Personen ohne deren Einwilligung hochzuladen;",
                  "keine Schadsoftware zu verbreiten, keine automatisierten Systeme (Bots, Scraper) zur missbräuchlichen Nutzung einzusetzen und die Plattform nicht durch übermäßige Anfragen zu beeinträchtigen;",
                  "keine kommerzielle Werbung oder Spam ohne unsere vorherige Zustimmung zu verbreiten;",
                  "die Standortfreigabe-Funktion nicht zu missbrauchen, um andere Nutzer:innen zu verfolgen, auszuspähen oder zu belästigen.",
                ].map((item) => (
                  <li
                    key={item}
                    className="flex gap-3 font-body text-body-md leading-[1.55] text-on-surface-variant"
                  >
                    <span
                      aria-hidden
                      className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-secondary"
                    />
                    {item}
                  </li>
                ))}
              </ul>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Verstöße gegen diese Pflichten können zur Löschung einzelner Inhalte, zur
                vorübergehenden Sperrung oder zur dauerhaften Kündigung des Nutzerkontos führen
                (siehe § 6).
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                § 4 Nutzungsrechte an hochgeladenen Inhalten
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Sie behalten sämtliche Rechte an den von Ihnen hochgeladenen Inhalten (Texte,
                Fotos, Videos, Profildaten). Um Ihre Inhalte innerhalb der Plattform anzeigen,
                speichern und an andere Nutzer:innen ausliefern zu können, räumen Sie uns ein
                einfaches, räumlich auf den Betrieb der Plattform beschränktes, zeitlich auf die
                Dauer der Veröffentlichung begrenztes Nutzungsrecht ein. Dieses Recht endet, sobald
                Sie den jeweiligen Inhalt löschen oder Ihr Konto schließen, vorbehaltlich technisch
                bedingter Restlaufzeiten (z. B. Backups, die im Rahmen üblicher Löschzyklen
                entfernt werden) und bereits an Dritte weitergegebener Inhalte (z. B. Beiträge,
                die andere Nutzer:innen bereits gesehen oder geteilt haben). Eine Nutzung Ihrer
                Inhalte zu Werbezwecken außerhalb der Plattform findet nicht statt.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                § 5 Verfügbarkeit und Änderungen der Plattform
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Wir sind bestrebt, Welope möglichst unterbrechungsfrei bereitzustellen, können
                jedoch keine ununterbrochene Verfügbarkeit garantieren. Wartungsarbeiten,
                technische Störungen oder Weiterentwicklungen können zu vorübergehenden
                Einschränkungen führen. Wir behalten uns vor, den Funktionsumfang der Plattform im
                Rahmen der Weiterentwicklung weiterzuentwickeln, zu ändern oder einzelne
                Funktionen einzustellen, soweit dies für Sie zumutbar ist.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                § 6 Kündigung und Löschung des Kontos
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Sie können Ihr Nutzerkonto jederzeit ohne Angabe von Gründen über die Funktion
                "Konto löschen" in den Einstellungen kündigen. Ihre Daten werden daraufhin gemäß
                unserer Datenschutzerklärung gelöscht. Wir können Ihnen bei einem Verstoß gegen
                diese Nutzungsbedingungen, insbesondere gegen § 3, nach vorheriger Abmahnung – bei
                schweren oder wiederholten Verstößen auch fristlos und ohne vorherige Abmahnung –
                den Zugang zur Plattform sperren oder Ihr Konto kündigen und löschen. Bei einer
                Kündigung durch uns werden wir Sie hierüber, soweit möglich, per E-Mail
                informieren.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                § 7 Haftungsbeschränkung
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Wir haften unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie nach den
                Vorschriften des Produkthaftungsgesetzes und bei Verletzung von Leben, Körper oder
                Gesundheit. Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten
                (Kardinalpflichten), deren Erfüllung die ordnungsgemäße Durchführung des Vertrags
                überhaupt erst ermöglicht und auf deren Einhaltung Sie regelmäßig vertrauen
                dürfen, haften wir der Höhe nach begrenzt auf den vertragstypischen,
                vorhersehbaren Schaden. Im Übrigen ist die Haftung für leicht fahrlässige
                Pflichtverletzungen ausgeschlossen. Für Inhalte, die Nutzer:innen veröffentlichen,
                sind ausschließlich diese selbst verantwortlich; wir machen uns fremde Inhalte
                nicht zu eigen.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                § 8 Änderungen dieser Nutzungsbedingungen
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Wir behalten uns vor, diese Nutzungsbedingungen mit Wirkung für die Zukunft zu
                ändern, soweit dies aufgrund geänderter rechtlicher Rahmenbedingungen, neuer
                Funktionen der Plattform oder aus sonstigen berechtigten Gründen erforderlich ist.
                Über wesentliche Änderungen informieren wir Sie mit angemessener Frist vor
                Inkrafttreten per E-Mail oder durch einen Hinweis innerhalb der App. Widersprechen
                Sie den geänderten Bedingungen nicht innerhalb von vier Wochen nach Zugang der
                Mitteilung, gelten sie als angenommen; hierauf werden wir Sie in der
                Änderungsmitteilung gesondert hinweisen. Im Fall eines Widerspruchs steht Ihnen
                das Recht zur außerordentlichen Kündigung Ihres Kontos zu.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                § 9 Anwendbares Recht und Gerichtsstand
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des
                UN-Kaufrechts. Zwingende verbraucherschützende Bestimmungen des Staates, in dem
                Sie als Verbraucher:in Ihren gewöhnlichen Aufenthalt haben, bleiben hiervon
                unberührt. Ist die Nutzer:in Kaufmann/-frau, juristische Person des öffentlichen
                Rechts oder öffentlich-rechtliches Sondervermögen, ist ausschließlicher
                Gerichtsstand für alle Streitigkeiten aus diesem Vertragsverhältnis der Wohnsitz
                des Betreibers (Liebenscheid).
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                § 10 Salvatorische Klausel
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam sein oder
                werden, bleibt die Wirksamkeit der übrigen Bestimmungen hiervon unberührt.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}
